/**
 * Flowbite tooltips for ticket overview toolbar buttons (all viewport sizes).
 * Tooltip nodes are appended to document.body so they are not clipped by the sticky toolbar.
 */
import Tooltip from 'flowbite/lib/esm/components/tooltip/index.js';

const TOOLTIP_PAIRS: ReadonlyArray<{ triggerId: string; tooltipId: string }> = [
    { triggerId: 'bulk-close-btn', tooltipId: 'bulk-close-tooltip' },
    { triggerId: 'bulk-reopen-btn', tooltipId: 'bulk-reopen-tooltip' },
    { triggerId: 'bulk-delete-btn', tooltipId: 'bulk-delete-tooltip' },
    { triggerId: 'bulk-mark-unread-btn', tooltipId: 'bulk-mark-unread-tooltip' },
    { triggerId: 'bulk-refresh-btn', tooltipId: 'bulk-refresh-tooltip' },
];

let activeInstances: Tooltip[] = [];

function mountTooltipNodesToBody(): void {
    for (const { tooltipId } of TOOLTIP_PAIRS) {
        const target = document.getElementById(tooltipId);
        if (target && target.parentElement !== document.body) {
            document.body.appendChild(target);
        }
    }
}

function clearAriaDescribedBy(): void {
    for (const { triggerId, tooltipId } of TOOLTIP_PAIRS) {
        const trigger = document.getElementById(triggerId);
        if (trigger?.getAttribute('aria-describedby') === tooltipId) {
            trigger.removeAttribute('aria-describedby');
        }
    }
}

function destroyActiveTooltips(): void {
    for (const instance of activeInstances) {
        instance.destroyAndRemoveInstance();
    }
    activeInstances = [];
    clearAriaDescribedBy();
}

function syncToolbarTooltips(): void {
    destroyActiveTooltips();
    for (const pair of TOOLTIP_PAIRS) {
        const trigger = document.getElementById(pair.triggerId);
        const target = document.getElementById(pair.tooltipId);
        if (!trigger || !target) {
            continue;
        }
        trigger.setAttribute('aria-describedby', pair.tooltipId);
        activeInstances.push(
            new Tooltip(target, trigger, {
                placement: 'top',
                triggerType: 'hover',
            }),
        );
    }
}

export function initTicketOverviewToolbarTooltips(): void {
    if (!document.getElementById('ticket-overview-toolbar')) {
        return;
    }

    mountTooltipNodesToBody();
    syncToolbarTooltips();
}
